import { render, staticRenderFns } from "./UiHelper.vue?vue&type=template&id=c9dfa6cc"
import script from "./UiHelper.vue?vue&type=script&lang=js"
export * from "./UiHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9dfa6cc')) {
      api.createRecord('c9dfa6cc', component.options)
    } else {
      api.reload('c9dfa6cc', component.options)
    }
    module.hot.accept("./UiHelper.vue?vue&type=template&id=c9dfa6cc", function () {
      api.rerender('c9dfa6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui-helper/UiHelper.vue"
export default component.exports